export const nftAddress = "0xba40d4F617aB1B3Ea0e70C0AaeA515471DF07C83";
export const minterAddress = "0x076aebfB789CeC47FE6c2918C7F38E13b62FC5f3";
